import createReducer from 'store/createReducer'
import { Action, Nullable } from 'store/model'
import { ActionType, type GetUsersResponseData } from 'store/users/types'

export interface UsersReducer {
  users: Nullable<GetUsersResponseData>
}

const defaultState: UsersReducer = {
  users: null,
}

export const usersReducer = createReducer<UsersReducer>(defaultState, {
  [ActionType.SET_USERS]: (state: UsersReducer, action: Action<Nullable<GetUsersResponseData>>) => ({
    ...state,
    users: action.payload,
  }),
})
